// extracted by mini-css-extract-plugin
module.exports = {"Kpis__Table":"Kpis_Kpis__Table__3NV88","Kpis__Table__Sorted":"Kpis_Kpis__Table__Sorted__2-xTl","Kpis__Table__AvatarContainer":"Kpis_Kpis__Table__AvatarContainer__2uei4"};